/** 格式化为 <input type="date"> 所需 YYYY-MM-DD（本地日历日） */
export const toDateInputValue = (date) => {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = String(date.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
};

const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

const addDays = (date, days) => {
	const next = new Date(date);
	next.setDate(next.getDate() + days);
	return next;
};

/** 以周一为一周起始 */
const startOfWeekMonday = (date) => {
	const d = startOfDay(date);
	const day = d.getDay();
	const offset = day === 0 ? -6 : 1 - day;
	return addDays(d, offset);
};

const startOfMonth = (year, month) => new Date(year, month, 1);

/** 自然季度起始（1–3 月 Q1，4–6 月 Q2，…） */
const startOfQuarter = (date) => {
	const d = startOfDay(date);
	const quarterStartMonth = Math.floor(d.getMonth() / 3) * 3;
	return new Date(d.getFullYear(), quarterStartMonth, 1);
};

const buildRollingMonthRange = (months) => {
	const to = startOfDay(new Date());
	const from = new Date(to);
	from.setMonth(from.getMonth() - months);
	return { from: toDateInputValue(from), to: toDateInputValue(to) };
};

/** 日历快捷项：本周 / 本月 / 本季度 / 本年 */
export const ORDER_LIST_DATE_RANGE_PRESETS = [
	{
		id: 'thisWeek',
		label: '本周',
		getRange: (now = new Date()) => {
			const to = startOfDay(now);
			const from = startOfWeekMonday(to);
			return { from: toDateInputValue(from), to: toDateInputValue(to) };
		},
	},
	{
		id: 'thisMonth',
		label: '本月',
		getRange: (now = new Date()) => {
			const to = startOfDay(now);
			const from = startOfMonth(to.getFullYear(), to.getMonth());
			return { from: toDateInputValue(from), to: toDateInputValue(to) };
		},
	},
	{
		id: 'thisQuarter',
		label: '本季度',
		getRange: (now = new Date()) => {
			const to = startOfDay(now);
			const from = startOfQuarter(to);
			return { from: toDateInputValue(from), to: toDateInputValue(to) };
		},
	},
	{
		id: 'thisYear',
		label: '本年',
		getRange: (now = new Date()) => {
			const to = startOfDay(now);
			const from = new Date(to.getFullYear(), 0, 1);
			return { from: toDateInputValue(from), to: toDateInputValue(to) };
		},
	},
];

/** 滚动月数快捷项：近 1/3/6/12 月（批量重匹配等） */
export const ORDER_ROLLING_MONTH_DATE_RANGE_PRESETS = [
	{ id: 'last1m', label: '近1月', getRange: () => buildRollingMonthRange(1) },
	{ id: 'last3m', label: '近3月', getRange: () => buildRollingMonthRange(3) },
	{ id: 'last6m', label: '近半年', getRange: () => buildRollingMonthRange(6) },
	{ id: 'last12m', label: '近1年', getRange: () => buildRollingMonthRange(12) },
];

/** 判断当前起止是否与某一快捷项一致（用于高亮） */
export const findMatchingDatePresetId = (from, to, presets = ORDER_LIST_DATE_RANGE_PRESETS) => {
	if (!from && !to) return null;

	for (const preset of presets) {
		const range = preset.getRange();
		if (range.from === from && range.to === to) {
			return preset.id;
		}
	}

	return null;
};
